import { render, staticRenderFns } from "./SoliDuration.vue?vue&type=template&id=51559529"
import script from "./SoliDuration.vue?vue&type=script&lang=js"
export * from "./SoliDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports